<template>
  <div :class="['page', $style.loadGamePage]">
    <template v-if="gameLoaded">
      <div ref="headerContainer" :class="[$globalStyle.headerContainer]">
        <HeaderActionButton
          :text="$t('back')"
          :iconLink="leftArrowIcon"
          :clickFunction="goBack"
          backBg="#000000"
          frontBg="#676767"
          textColor="#FFFFFF"
          :icon-only="isMobile"
          :button-width="isMobile ? '60px' : isTablet ? '130px' : '160px'"
        />
        <div :class="[$globalStyle.header, $globalStyle.hostHeader]">
          <div :class="$globalStyle.headerLeft">
            <div :class="$globalStyle.logoContainer">
              <img :src="saboteurLogo" alt="icon" :class="$globalStyle.headerLogo" />
              <div :class="$globalStyle.headerTitle">{{ $t("saboteur") }}</div>
            </div>
          </div>
          <div :class="$globalStyle.headerRight">
            <!-- <div v-if="realTextIndex" :class="$globalStyle.headerItem">
              <div :class="$globalStyle.headerItemLabel">Original Text</div>
              <div :class="[$globalStyle.headerItemText, $globalStyle.headerItemHostSaboteurText]">
                Text {{ textIndexes[realTextIndex] }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div :class="$gameTemplateStyle.bodyContainer">
        <h1 :class="$gameTemplateStyle.bodyText">{{ $t("create") }}</h1>
        <div :class="$gameTemplateStyle.formContainer">
          <div :class="$gameTemplateStyle.form">
            <GameSetupCoreFields
              :form="form"
              :disciplineOptions="disciplineOptions"
              :codeLanguageOptions="codeLanguageOptions"
              :formModuleClass="$gameTemplateStyle.formModule1"
              :imageUploadFailed="imageUploadFailed"
              :showTitleField="true"
              :showImageField="!!form.discipline"
              :disableDiscipline="true"
              :disableCodeLanguage="true"
              :replaceImagePlaceholderWhenExisting="true"
              @update:form="form = $event"
            />
            <div v-if="hasExistingImage" :class="$style.gameImageSubText">
              <u>{{ $t('note') }}:</u> {{ $t('image-replace-note') }}
            </div>

            <div ref="textsContainer" :class="$style.textsContainer">
              <div :class="$style.gameTextsBoxTitleContainer">
                <div :class="$style.gameTextsBoxTitle">
                  {{ $t('game-texts') }}
                </div>

                <div :class="$style.gameTextsBoxCorrectText">
                  {{ $t('correct-text') }}:
                  <span :class="$style.gameTextsBoxCorrectTextLabel">
                    {{ $t('text') }} {{ form.realTextLabel }}
                  </span>
                </div>

              </div>

              <div v-if="form.realTextLabel" :class="$style.gameTextsBoxSubText">
                {{ $t('edit-texts-note') }}
              </div>
              <div :class="$style.gameTextsBoxContainer">
                <GameTextsBox
                  :texts="form.texts"
                  :discipline="form.discipline"
                  :codeLanguage="form.codeLanguage"
                  :textTitle="form.title"
                  :realTextId="form.realTextId ? form.realTextId : null"
                  :realTextLabel="form.realTextLabel ? form.realTextLabel : ''"
                  @update-texts="updateGameTexts"
                  :editTexts="true"
                  :showTextsOnly="true"
                  :imageUrl="form.imageUrl ?? ''"
                  :showImageButton="true"
                />
              </div>
            </div>
          </div>
        </div>
        <div :class="$gameTemplateStyle.ctaContainer">
          <UtilButton
            :class="$gameTemplateStyle.cta"
            :text="$t('create')"
            :clickFunction="createGame"
            size="lg"
            frontBg="#3F72AF"
            backBg="#112D4E"
            textColor="#FFFFFF"
            :button-width="isMobile ? '200px' : isTablet ? '220px' : '240px'"
          />
        </div>
      </div>
    </template>
    <template v-if="gameFetchError">
      <div :class="$style.errorContainer">
        <div :class="$style.errorInnerContainer">
          <img :class="$style.errorIcon" :src="brokenComputerImg" alt="error" />
          <div :class="$style.errorText">{{ $t('unexpected-error') }}</div>
          <div :class="$style.errorSubText">Please refresh the page or go back to the game load page</div>
          <div :class="$style.errorCta">
            <UtilButton
              :text="$t('go-back')"
              :clickFunction="goBack"
              size="lg"
              backBg="#A14000"
              frontBg="#DB7532"
              textColor="#FFFFFF"
              buttonHeight="48px"
              :button-width="isMobile ? '200px' : isTablet ? '220px' : '240px'"
            />
          </div>
        </div>
      </div>
    </template>
    <div v-if="isLoading" :class="['loader-container']">
      <img :src="hostLoaderGif" alt="loader-gif" class="loader-gif" />
      <!-- <div :class="['loader']">Loading ...</div> -->
    </div>
  </div>
</template>

<script>
import { useGameStore } from "@/stores/gameStore";
import styles from "@/css/CopyGameView.module.css";
import gameTemplateStyles from "@/css/GameViewTemplate.module.css";
import globalStyles from "@/css/global.module.css";
import SaboteurLogo from "../assets/saboteur-logo.svg";
import LeftArrowIcon from "@/assets/icons/left-arrow.svg";
import DetectiveHatIcon from "@/assets/icons/detective-hat.svg";
import UsersIcon from "@/assets/icons/users.svg";
import EmptyHourglassIcon from "@/assets/icons/empty-hourglass.svg";
import CategorizeIcon from "@/assets/icons/categorize.svg";
import NewDocumentIcon from "@/assets/icons/new-document.svg";
import SheetOfPaperIcon from "@/assets/icons/sheet-of-paper.svg";
import SourceCodeIcon from "@/assets/icons/source-code.svg";
import AIIcon from "@/assets/icons/ai.svg";
import SettingsIcon from "@/assets/icons/settings-blue.svg";
import SortDownIcon from "@/assets/icons/sort-down-blue.svg";
import DoneIcon from "@/assets/icons/done.svg";
import HostLoaderGif from "@/assets/gifs/host-loader.svg";
import BrokenComputerImg from "@/assets/broken-computer.png";
import UtilButton from "@/components/util/UtilButton.vue";
import { toast } from "vue3-toastify";
import gameService from "@/services/game.service";
import {
  codeLanguageOptions,
  disciplineOptions,
  // inaccuracyLevelOptions,
  // llmOptions,
  // originalTextDisciplineIds,
  textLabels,
  // titleDisciplineIds,
} from "@/utils/data";
import GameTextsBox from "@/components/playGame/GameTextsBox.vue";
import HeaderActionButton from "@/components/buttons/HeaderActionButton.vue";
import useDeviceType from "@/utils/useDeviceType";
import GameSetupCoreFields from "@/components/util/GameSetupCoreFields.vue";
import {
  createCopyGameFormDefaults,
  createCopyGameFormFromLoadedGame,
} from "@/utils/gameForm";
import { validateSharedGameForm } from "@/utils/gameFormValidation";

const device = useDeviceType();

export default {
  components: {
    UtilButton,
    GameTextsBox,
    HeaderActionButton,
    GameSetupCoreFields,
  },
  name: "CopyGameView",
  props: {},
  data() {
    return {
      isLoading: true,
      gameLoaded: false,
      gameFetchError: false,
      saboteurLogo: SaboteurLogo,
      leftArrowIcon: LeftArrowIcon,
      detectiveHatIcon: DetectiveHatIcon,
      usersIcon: UsersIcon,
      emptyHourglassIcon: EmptyHourglassIcon,
      categorizeIcon: CategorizeIcon,
      newDocumentIcon: NewDocumentIcon,
      sheetOfPaperIcon: SheetOfPaperIcon,
      sourceCodeIcon: SourceCodeIcon,
      aiIcon: AIIcon,
      settingsIcon: SettingsIcon,
      sortDownIcon: SortDownIcon,
      doneIcon: DoneIcon,
      hostLoaderGif: HostLoaderGif,
      brokenComputerImg: BrokenComputerImg,
      disciplineOptions: disciplineOptions,
      codeLanguageOptions: codeLanguageOptions,
      imageUploadFailed: false,
      // inaccuracyLevelOptions: inaccuracyLevelOptions,
      // llmOptions: llmOptions,
      // titleDisciplineIds: titleDisciplineIds,
      // originalTextDisciplineIds: originalTextDisciplineIds,
      // titleDisciplines: ["Famous Fiction"],
      // originalTextDisciplines: ["Educational", "Code", "News/History/Real Events"],
      // disciplineOptions: ["Famous Fiction", "Educational", "Code", "News/History/Real Events"],
      // codeLanguageOptions: ["C", "C++", "Java", "Python", "C#", "JavaScript"],
      // llmOptions: ["Grok", "Gemini", "ChatGPT", "Copilot", "Combination"],
      // inaccuracyLevelOptions: ["Minor", "Medium", "Major"],
      showAdvanced: false,
      form: createCopyGameFormDefaults(),
      gameTextEdit: false,
      game: {},
      fbGameDocId: "",
      playerId: null,
      userAvatarUrl: "",
      joinCode: "",
      realTextIndex: null,
      textLabels: textLabels,
      // disciplineOptionValues: {
      //   "Famous Fiction": "famousfiction",
      //   Educational: "education",
      //   Code: "code",
      //   "News/History/Real Events": "news_history_realevents",
      // },
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $gameTemplateStyle() {
      return gameTemplateStyles;
    },
    $globalStyle() {
      return globalStyles;
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
    hasExistingImage() {
      return !!(this.form.imageUrl && !this.form.imageUrl.startsWith("blob:"));
    },
  },
  methods: {
    goHome() {
      this.$router.push({ name: "home" });
    },
    goBack() {
      // console.log("go back clicked");
      this.$router.push({ name: "load-game", params: {} });
    },
    async loadGameData() {
      try {
        let loadGameResponse = await gameService.loadGame2({
          joinCode: parseInt(this.gameStore.copyGameJoinCode),
        });

        // console.log("loadGameResponse: ", loadGameResponse);
        if (
          loadGameResponse &&
          loadGameResponse.status === 200 &&
          loadGameResponse.data &&
          loadGameResponse.data.game
        ) {
          let gameData = loadGameResponse.data.game;
          gameData.imageUrl = gameData.imageUrl ?? "";
          let realTextId = null;
          let realTextLabel = "";
          // console.log("--- before texts: ", gameData.texts);
          let modifiedTexts = gameData.texts.map((text, index) => {
            if (text.isReal) {
              realTextId = parseInt(gameData.uniqueTextId[index]);
              realTextLabel = this.textLabels[index + 1];
            }

            return {
              id: gameData.uniqueTextId[index],
              label: this.textLabels[index + 1],
              content: text.content,
            };
          });
          // console.log("--- modifiedTexts: ", modifiedTexts);

          gameData.texts = modifiedTexts;
          gameData.realTextId = realTextId;
          gameData.realTextLabel = realTextLabel;
          this.hydrateFromLoadedGame(gameData);
        } else {
          //   toast("Some error occurred while joining the game. Please try again later", {
          //     type: "error",
          //   });
          this.gameFetchError = true;
        }
      } catch (error) {
        console.error("Error: ", error);
        toast(this.$t("unexpected-error"), {
          type: "error",
        });

        this.gameFetchError = true;
      } finally {
        // do nothing
      }
    },
    hydrateFromLoadedGame(gameData) {
      if (!gameData) {
        this.gameFetchError = true;
        return;
      }

      const normalizedGameData = JSON.parse(JSON.stringify(gameData));
      normalizedGameData.imageUrl = normalizedGameData.imageUrl ?? "";

      if (
        normalizedGameData.playerNum == null ||
        normalizedGameData.groupLimit == null
      ) {
          console.error("Copy game is missing required config", {
          joinCode: this.gameStore.copyGameJoinCode,
          playerNum: normalizedGameData.playerNum,
          groupLimit: normalizedGameData.groupLimit,
          gameData: normalizedGameData,
        });
        toast(this.$t("copy-game-config-missing"), {
          type: "error",
        });
        this.gameFetchError = true;
        return;
      }

      this.game = normalizedGameData;
      this.form = createCopyGameFormFromLoadedGame(normalizedGameData);
      this.gameLoaded = true;
    },
    validateCreateGameForm() {
      const notify = (message) => {
        toast(message, { type: "error" });
      };

      if (
        !validateSharedGameForm({
          form: this.form,
          t: (key) => this.$t(key),
          notify,
          requireDiscipline: true,
          requireTitle: true,
        })
      ) {
        return false;
      }

      // validate the prefilled texts
      if (!this.form.texts) {
        toast(this.$t("error-game-texts"), { type: "error" });

        return false;
      }

      let gameTextsError = false;
      this.form.texts.forEach((text) => {
        if (!text.content) {
          gameTextsError = true;
          toast(this.$t("error-empty-text", { label: text.label }), {
            type: "error",
          });
        }
      });

      if (gameTextsError) {
        return false;
      }

      return true;
    },
    async createGame() {
      if (!this.validateCreateGameForm()) {
        return false;
      }

      try {
        this.isLoading = true;

        // make API call
        const payload = {
          hostName: this.form.hostName,
          allowedPlayers: this.form.allowedPlayers,
          groupLimit: this.form.groupLimit,
          readingTime: this.form.readingTime,
          discussionTime: this.form.discussionTime,
          title: this.form.title,
          discipline: this.form.discipline,
          codeLanguage: this.form.codeLanguage,
          preliminaryReason: this.form.preliminaryReason,
          finalReason: this.form.finalReason,
          texts: this.form.texts,
          realTextId: this.form.realTextId,
          realTextLabel: this.form.realTextLabel,
        };

        let copyGameResponse = await gameService.copyGame(payload);

        if (
          copyGameResponse &&
          copyGameResponse.status === 200 &&
          copyGameResponse.data &&
          copyGameResponse.data.game
        ) {
          let newGameData = copyGameResponse.data.game;
          if (newGameData.rejoinToken) {
            localStorage.setItem(
              `rejoinToken_${newGameData.joinCode}`,
              JSON.stringify({
                token: newGameData.rejoinToken,
                createdAt: Date.now(),
              })
            );
          }
          this.game = newGameData;
          localStorage.setItem("lastJoinCode", newGameData.joinCode);
          localStorage.setItem("lastPlayerName", this.form.hostName);
          // --- IMAGE HANDLING (CopyGameView) ---
          let finalImageUrl = "";

          const hasUrl = !!this.form.imageUrl && !this.form.imageUrl.startsWith("blob:");
          const hasFile = !!this.form.imageFile;

          if (newGameData && (hasUrl || hasFile)) {
            this.form.imageUploading = true;
            this.imageUploadFailed = false;

            try {
              const res = await gameService.uploadGameImage(
                newGameData.gameId,
                hasFile ? this.form.imageFile : null,
                hasUrl ? this.form.imageUrl : ""
              );

              const s3Url = res?.image_url;
              if (!s3Url) throw new Error("uploadGameImage returned no image_url");

              finalImageUrl = s3Url;
              this.form.imageUrl = s3Url;
              this.form.imageFile = null;
            } catch (e) {
              console.error("uploadGameImage failed:", e);

              const detail = e?.response?.data?.detail;
              toast(detail || "Game created, but image update/upload failed.", { type: "error" });

              this.imageUploadFailed = true;
            } finally {
              this.form.imageUploading = false;
            }
          }

          // modify texts
          let realTextId = null;
          let realTextLabel = "";
          let modifiedTexts = newGameData.texts.map((text, index) => {
            if (text.isReal) {
              realTextId = parseInt(newGameData.uniqueTextId[index]);
              realTextLabel = this.textLabels[index + 1];
            }

            return {
              id: newGameData.uniqueTextId[index],
              label: this.textLabels[index + 1],
              content: text.content,
            };
          });

          let combinedText = `Original Text: ${newGameData.originalText}, Language: ${this.form.codeLanguage}, Discipline: ${this.form.discipline}`; // @TODO: this should be cleaned
          // console.log("combinedText: ", combinedText);

          // Save game data in Pinia store
          let gameStoreData = {
            host: { id: newGameData.uniquePlayerId, name: this.form.hostName },
            joinCode: newGameData.joinCode,
            allowedPlayers: Number(this.form.allowedPlayers),
            readingTime: this.form.readingTime,
            discussionTime: this.form.discussionTime,
            textTitle: newGameData.textTitle,
            discipline: this.form.discipline,
            inaccuracyLevels: this.form.inaccuracyLevels,
            originalText: this.form.originalText,
            combinedText: combinedText,
            codeLanguage: this.form.codeLanguage ? this.form.codeLanguage : "",
            llm: "",
            enableFinalReason: this.form.finalReason ? 1 : 0,
            enablePreliminaryReason: this.form.preliminaryReason ? 1 : 0,
            fbGameDocId: newGameData.fbGameDocId,
            gameId: newGameData.gameId,
            uniqueTextId: newGameData.uniqueTextId,
            texts: modifiedTexts,
            realTextId: realTextId,
            realTextLabel: realTextLabel,
            imageUrl: finalImageUrl,
            phase: "JOIN",
            groupLimit: Number(this.form.groupLimit),
          };

          this.gameStore.clearCopyGameJoinCode();
          this.gameStore.clearCopyGameSource();
          this.gameStore.setGameData(
            gameStoreData,
            true,
            { id: newGameData.uniquePlayerId, name: this.form.hostName, avatar: newGameData.userAvatarUrl },
            false
          ); // Set `isHost` to true for the host
          sessionStorage.setItem("isReconnectFlow", "false");
          // Navigate to PlayGameView
          this.$router.push({ name: "play-game"});
        } else {
          // error
          console.error("Some error occurred while making the API call!");
          toast(this.$t("unexpected-error"), {
            type: "error",
          });
        }
      } catch (error) {
        console.error("Error: ", error);
        toast(this.$t("unexpected-error"), {
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },
    updateGameTexts(updatedTexts) {
      // Update texts when edited in GameTextsBox
      this.form.texts = updatedTexts;
    },
  },
  async mounted() {
    if (!this.gameStore.copyGameJoinCode) {
      this.goBack();
      return;
    }

    const copyGameSource = this.gameStore.copyGameSource;
    const copyGameJoinCode = this.gameStore.copyGameJoinCode;

    if (copyGameSource && Number(copyGameSource.joinCode) === Number(copyGameJoinCode)) {
      this.hydrateFromLoadedGame(copyGameSource);
    } else {
      // make API call to fetch game data
      await this.loadGameData();
    }

    this.isLoading = false;
  },
  beforeUnmount() {
    if (this.form?.imageUrl?.startsWith("blob:")) {
      URL.revokeObjectURL(this.form.imageUrl);
    }
  },
  setup() {
    const gameStore = useGameStore();

    return {
      gameStore,
    };
  },
  watch: {},
};
</script>

<style scoped></style>
